import { createObjectSteps } from './step-definitions'
import { CreateObjectStepConfig } from './types'

export const getCreateObjectStepById = (
  stepId: string | undefined,
): CreateObjectStepConfig | undefined =>
  createObjectSteps.find((step) => step.id === stepId)
